import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import { Modal, Form, Input } from 'antd'
import { withFormik } from 'formik'
import * as yup from 'yup'

import { GET_PRESET_GROUP_BY_ID } from '../../../../graphql/queries'

const validationSchema = () =>
  yup.object().shape({
    name: yup.string().required()
  })

export const handleSubmit = async (
  values,
  { props, setSubmitting, resetForm }
) => {
  const { onEdit, onClose } = props

  setSubmitting(true)

  await onEdit(values)

  resetForm()

  onClose()
  setSubmitting(false)
}

export const PresetGroupForm = ({
  data,
  values,
  visible,
  onClose,
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  errors
}) => {
  return (
    <Modal
      visible={visible}
      title={values.id ? 'Edit Preset Group' : 'Create a new Preset Group'}
      okText={values.id ? 'Save' : 'Create'}
      onCancel={onClose}
      onOk={handleSubmit}
    >
      {!data.loading && (
        <Form layout="vertical">
          <Form.Item
            label="PresetGroup Name"
            help={touched.name && errors.name ? errors.name : ''}
            validateStatus={touched.name && errors.name ? 'error' : undefined}
          >
            <Input
              name="name"
              placeholder="PresetGroup Name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </Form.Item>
        </Form>
      )}
    </Modal>
  )
}

PresetGroupForm.propTypes = {
  data: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired
}

export default compose(
  graphql(GET_PRESET_GROUP_BY_ID, {
    options: ({ data }) => {
      return {
        variables: {
          id: data.id || 0
        }
      }
    }
  }),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: ({ data }) => {
      return {
        id: data.presetGroup && data.presetGroup.id,
        name: (data.presetGroup && data.presetGroup.name) || ''
      }
    },
    handleSubmit,
    validationSchema,
    displayName: 'PresetGroupForm'
  })
)(PresetGroupForm)



// WEBPACK FOOTER //
// ./src/pages/PresetGroup/components/PresetGroupForm/index.js